import { STCompanyInfo, Logo } from "@stss/ui";
import classNames from "classnames";

import { useLocale } from "@calcom/lib/hooks/useLocale";
import { HeadSeo } from "@calcom/ui";

import Loader from "@components/Loader";

const stWebsiteUrl = process.env.NEXT_PUBLIC_ST_WEBSITE_URL || "https://www.simpletherapy.com/";

interface Props {
  title: string;
  description: string;
  footerText?: React.ReactNode | string;
  showLogo?: boolean;
  heading?: string;
  loading?: boolean;
}

export default function AuthContainer(props: React.PropsWithChildren<Props>) {
  const { t } = useLocale();
  return (
    <div className="flex min-h-screen flex-col justify-center bg-[#f3f4f6] py-12 sm:px-6 lg:px-8">
      <HeadSeo title={props.title} description={props.description} isBrandingHidden />
      {props.showLogo && (
        // eslint-disable-next-line @next/next/no-img-element
        <div className="text-center">
          <Logo logoLink={stWebsiteUrl} logoTitle={t("st_brand_name")} size="large" />
          <p className="text-xl font-semibold">{t("scheduling_service") + " " + t("login")}</p>
        </div>
      )}

      <div className={classNames(props.showLogo ? "text-center" : "", "sm:mx-auto sm:w-full sm:max-w-md")}>
        {props.heading && <h2 className="font-cal text-emphasis text-center text-3xl">{props.heading}</h2>}
      </div>
      {props.loading && (
        <div className="bg-muted absolute z-50 flex h-screen w-full items-center">
          <Loader />
        </div>
      )}
      <div className="mb-auto mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="border-1 mx-2 rounded-md border-gray-200 bg-white px-4 py-10 sm:px-10">
          {props.children}
        </div>
        <div className="mt-8 px-3 sm:mx-auto sm:w-full sm:max-w-md">
          <STCompanyInfo />
        </div>
        <div className="text-default mt-8 text-center text-sm">{props.footerText}</div>
      </div>
    </div>
  );
}
